import React from "react";
import { Button } from "react-bootstrap";
import * as FileSaver from "file-saver";

class BatchErrorModal extends React.Component {
  isNetworkError = (errorMessage) => {
    const networkPatterns = [
      /Error\s*(408|429|500|502|503|504|505)/i,
      /timeout/i,
      /network/i,
      /ECONNABORTED/i,
      /ECONNREFUSED/i,
      /ECONNRESET/i,
    ];
    return networkPatterns.some(pattern => pattern.test(errorMessage));
  };

  downloadErrorReport = async () => {
    try {
      const { failedRecords } = this.props;

      const reportData = failedRecords.map((record, index) => ({
        "#": index + 1,
        ...(record.excelRow ? { "Excel Row": record.excelRow } : {}),
        "Item (SKU)": record.sku,
        "DC": record.dc,
        "Error": record.errorMessage
      }));

      const XLSX = await import("xlsx");

      const ws = XLSX.utils.json_to_sheet(reportData);

      ws["!cols"] = [
        { wch: 5 },
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
        { wch: 60 }
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Error Report");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "Batch_Upload_Error_Report.xlsx");
    } catch (error) {
      console.error("Failed to download error report:", error.message);
      alert("Failed to download error report. Please try again.");
    }
  };

  render() {
    const { isOpen, failedRecords, totalRecords, onClose } = this.props;

    if (!isOpen) return null;

    const showExcelRow = failedRecords.some(r => r.excelRow);
    const networkErrors = failedRecords.filter(r => this.isNetworkError(r.errorMessage));
    const allNetworkErrors = networkErrors.length === failedRecords.length;
    const hasNetworkErrors = networkErrors.length > 0;

    let subtitleMessage;
    if (allNetworkErrors) {
      subtitleMessage = "Network issues encountered. Please try again.";
    } else if (hasNetworkErrors) {
      subtitleMessage = "Some items failed due to network issues and others require corrections in your Excel file. Please try again.";
    } else {
      subtitleMessage = "Please correct the following items in your Excel file and try again.";
    }

    return (
      <div className="batch-error-overlay">
        <div className="batch-error-modal">
          <div className="batch-error-header">
            <div className="batch-error-title">
              <i className="material-icons" style={{ color: "#dc3545", fontSize: "28px" }}>
                warning
              </i>
              <h4>Errors Found in Batch Upload</h4>
            </div>
            <p className="batch-error-subtitle">
              {failedRecords.length} of {totalRecords} items failed to load.{" "}
              {subtitleMessage}
            </p>
          </div>
          <div className="batch-error-table-container">
            <table className="batch-error-table">
              <thead>
                <tr>
                  <th>#</th>
                  {showExcelRow && <th>Excel Row</th>}
                  <th>Item (SKU)</th>
                  <th>DC</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {failedRecords.map((record, index) => (
                  <tr key={`${record.sku}-${record.dc}-${index}`}>
                    <td>{index + 1}</td>
                    {showExcelRow && <td>{record.excelRow}</td>}
                    <td>{record.sku}</td>
                    <td>{record.dc}</td>
                    <td className="batch-error-message">{record.errorMessage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="batch-error-actions">
            <Button
              bsStyle="info"
              className="btn-sm"
              onClick={this.downloadErrorReport}
            >
              <i className="material-icons" style={{ fontSize: "16px", verticalAlign: "middle", marginRight: "4px" }}>
                file_download
              </i>
              Download Error Report
            </Button>
            <Button
              bsStyle="warning"
              className="btn-sm"
              onClick={onClose}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default BatchErrorModal;
